/**
 * A readable message from an API error, whatever shape DRF returned:
 * {"error": "..."}, {"detail": "..."}, {"field": ["..."]}, ["..."], "..." — never just "status code 400".
 */
export function apiErrorMessage(err, fallback = 'Something went wrong. Please try again.') {
  const data = err?.response?.data;
  const first = (v) => {
    if (!v) return '';
    if (typeof v === 'string') return v;
    if (Array.isArray(v)) return first(v[0]);
    if (typeof v === 'object') {
      for (const key of ['error', 'detail', 'message', 'non_field_errors']) {
        const m = first(v[key]);
        if (m) return m;
      }
      for (const val of Object.values(v)) {
        const m = first(val);
        if (m) return m;
      }
    }
    return '';
  };
  const msg = first(data);
  if (msg && !/^<!doctype|^<html/i.test(msg)) return msg;
  if (!err?.response) return 'Could not reach the server. Check your connection and try again.';
  return fallback;
}

export default apiErrorMessage;
